const createObstacle = (x, w, h, color) => {
    return {
        x, w, h, color
    }
}
export default createObstacle